export default () => async (dispatch, getState, { api }) => {
  const response = await api.debtors.getDebtors("needs_review");
  return response.count;
};
